import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { FooterComponent } from '../../components/footer/footer.component'
import { HeaderComponent } from '../../components/header/header.component'

@Component({
  selector: 'app-content-layout',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, RouterOutlet],
  templateUrl: './content-layout.component.html',
})
export class ContentLayoutComponent {}
